import { useContext, useMemo } from 'react';
import { useTimezone } from '../useTimezone';
import { CalendarContext } from '../../contexts/CalendarContext';

export const useDayOfWeek = (date: Date) => {
    const { timezone } = useContext(CalendarContext);
    const { parseDate } = useTimezone(timezone);

    const { dayOfWeek } = useMemo(() => {
        return parseDate(date);
    }, [date, parseDate]);

    return dayOfWeek;
};
